import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import styles from './styles.module.scss';
import Modal from 'react-modal';

class SlidePaneView extends React.Component {
  constructor(props) {
    super(props);

    this.handleOnAfterOpen = this.handleOnAfterOpen.bind(this);
  }

  handleOnAfterOpen(){
    if(this.props.onAfterOpen){
      this.props.onAfterOpen();
    }
  }

  render() {
    var {
      show,
      onRequestClose,
      onAfterOpen,
      children,
      className,
      overlayClassName,
      direction,
      width
    } = this.props;

    return (
      <Modal
        className={ cx(styles.slidePane, styles[direction?direction:'left'], className) }
        style={{
          content: { width: width || 'auto' }
        }}
        overlayClassName={ cx(styles.overlay, overlayClassName)}
        closeTimeoutMS={ 500 }
        isOpen={ show }
        onAfterOpen={ this.handleOnAfterOpen }
        onRequestClose={ onRequestClose }
        ariaHideApp={false}
        contentLabel={ `Modal` }>
        <div className={styles.content}>
          { children }
        </div>
      </Modal>
    );
  }
}

SlidePaneView.propTypes = {
  show: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func,
  onAfterOpen: PropTypes.func,
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
  overlayClassName: PropTypes.string,
  from: PropTypes.oneOf(['left', 'right', 'bottom']),
  width: PropTypes.string
}

export default SlidePaneView;